<template>
    <div>
        <el-checkbox v-model="check" v-on:change="updateStore">{{ $l10n.__('Rapprocher') }}</el-checkbox>
    </div>
</template>

<script>
import Store from './../../store/reconciliation.js'

export default {
    props : ['default', 'document', 'reference', 'amount', 'pay_type'],
    data() {
        return {
            sharedState: Store.state,

            check: this.default,
            uniqueId: ''
        }
    },
    methods:{
        updateStore: function (check) {
            if (check) {
                const reconciliation = {
                    id: '_' + Math.random().toString(36).substr(2, 9),
                    ref: this.reference,
                    date: this.sharedState.transactionDate,
                    amount: this.amount,
                    document: this.document,
                    pay_type: this.pay_type
                }
                this.uniqueId = reconciliation.id
                Store.addReconciled(reconciliation);
                this.$emit('new-payment-confirmed')
            } else {
                Store.delReconciled(this.uniqueId)
                this.uniqueId = ''
            }
        }
    }
}
</script>
